import React from "react";
import biodent from "../../assets/images/biodent.webp";
import { Link } from "react-router-dom";
import BASE_URL from "../../config";
import menuItems from "../Header/menuData";
const Footer = () => {
  const year = new Date().getFullYear();
  const textStyle = "font-secondary text-[1.6rem] text-white";
  return (
    <div className="bg-darkblue py-[10vh]">
      <div className="container">
        <Link to={`${BASE_URL}`}>
          <img src={biodent} className="w-[100px] h-auto" />
        </Link>
        <div className="flex justify-between gap-[2rem] lg:flex-nowrap flex-wrap">
          <div className="lg:w-[30%] w-[100%]">
            <h3 className="font-secondary font-medium text-[1.8rem] text-white mt-[2rem]">
              How bioalign works
            </h3>
            <p className={`${textStyle} font-light mt-[20px]`}>
            At our dental clinic, we believe that a smile is not just a reflection of good oral health, but also a powerful first impression that can leave a lasting impact.
            </p>
          </div>
          <div className="lg:w-[20%] md:w-[45%] w-[100%]">
            <h3 className={`${textStyle} font-medium mt-[2rem] `}>
              Quick links
            </h3>
            <div className="mt-[20px]">
              {/* {menuItems.map((item, index) => {
                <Link to={item.path} key={index}>
                  <div
                    className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                  >
                    {item.label}
                  </div>
                </Link>;
              })} */}
              {menuItems.map((item) => (
                <Link to={item.path} key={item.key}>
                  <div
                    className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                  >
                    {item.label}
                  </div>
                </Link>
              ))}
              {/* <Link to="/" className={`${textStyle} font-light text-[1.4rem]`}>
                Home
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  About us
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Benefits
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Blog
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Contact us
                </div>
              </Link> */}
            </div>
          </div>
          <div className="lg:w-[30%] md:w-[45%] w-[100%]">
            <h3 className={`${textStyle} font-medium mt-[2rem] `}>
              Categories
            </h3>
            <div className="mt-[20px]">
              <Link>
                <div className={`${textStyle} font-light text-[1.4rem]`}></div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Parent
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Adult
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Kids
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Fast and Simple Bio Aligners
                </div>
              </Link>
            </div>
          </div>
          <div className="lg:w-[30%] md:w-[45%] w-[100%]">
            <h3 className={`${textStyle} font-medium mt-[2rem] `}>Process</h3>
            <div className="mt-[20px]">
              <Link>
                <div className={`${textStyle} font-light text-[1.4rem]`}>
                  connect with your Bio Aligners provider
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Get you first fit
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Keep your brand-new smile
                </div>
              </Link>
            </div>
          </div>
          <div className="lg:w-[30%] md:w-[45%] w-[100%]">
            <h3 className={`${textStyle} font-medium mt-[2rem] `}>
              Bioalign Cost
            </h3>
            <div className="mt-[20px]">
              <Link to={`${BASE_URL}/app/clinic`}>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Find a Clinic
                </div>
              </Link>
              <Link to={`${BASE_URL}/app/doctor`}>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Find a Doctor
                </div>
              </Link>
              <Link>
                <div className={`${textStyle} font-light text-[1.4rem]`}>
                  Get Bio Aligners
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Free Assessment
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Request appointment
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  Contact Us
                </div>
              </Link>
              <Link>
                <div
                  className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}
                >
                  smile view
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className="w-full h-[1px] bg-white my-[20px]"></div>
        <div className="flex justify-center lg:justify-between flex-col md:flex-row gap-2 items-center ">
          <h3 className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
            © {year} Bio Aligners. All rights reserved.
          </h3>
          <div className="flex  gap-6">
            <Link>
              <div className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
                FAQ
              </div>
            </Link>
            <Link>
              <div className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
                Careers
              </div>
            </Link>
            <Link>
              <div className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
                Terms of Use
              </div>
            </Link>
            <Link>
              <div className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
                Sitemap
              </div>
            </Link>
            <Link>
              <div className={`${textStyle} font-light mt-[5px] text-[1.4rem]`}>
                Privacy Policy
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
